
/**
 * Helper functions to reset error everytime the user navigates
 */
export const mixin = {
    data () {
        return {
            step: 1
        }
    },

    watch: {
        step () {
            this.navigating()
        }
    },

    methods: {
        navigating () {
            this.$store.commit('updatePageInfo', {'error': ''})
        }
    }
}
// wrapper
export const loading = function (vueMethod) {

    return async function loadingWrapper () {
        const vueContext = this
        this.$store.commit('updatePageInfo', {loading: true, error: ''})

        try {
            await vueMethod.call(vueContext)
        } catch (error) {
            console.error(error)
            this.$store.dispatch('error', 'Something wrong happened. Try again later :(')
        }
        this.$store.commit('updatePageInfo', {loading: false})
    }
}



// WEBPACK FOOTER //
// ./apps/account/utils.js